import {EditBundleCoverImagesUpload} from "../../../../calls/useCases/editBundle/cover-images";
import {EditSessionCoverImagesUpload} from "../../../../calls/useCases/editService/cover-images";
import {EditLiveEventCoverImagesUpload} from "../../../../liveEvents/useCases/edit-live-event/cover-images";
import {EditProductCoverImagesUpload} from "../../../../products/useCases/edit-product/cover-images";
import {OfferingFormCheckoutFormWrapper} from "../../general/checkout-form/wrapper";
import {LiveEventAttendeesFormFields} from "../../live-events/attendees";
import {LiveEventGenInfoFormFields} from "../../live-events/gen-info";
import {LiveEventLocationFormFields} from "../../live-events/location";
import {ProductGenInfoFormFields} from "../../products/gen-info";
import {ProductPricingFormFields} from "../../products/pricing";
import {ProductSettingsFormFields} from "../../products/settings";
import {BundleSessionAvailabilityFormFields} from "../../session-bundle/bundle/availability";
import {BundleSessionGenInfoFormFields} from "../../session-bundle/bundle/gen-info";
import {BundleSessionLocationFormFields} from "../../session-bundle/bundle/location";
import {BundleSessionSessionPeriodFormFields} from "../../session-bundle/bundle/session-period";
import {SessionAvailabilityFormFields} from "../../session-bundle/session/availability";
import {SessionGenInfoFormFields} from "../../session-bundle/session/gen-info";
import {SessionLocationFormFields} from "../../session-bundle/session/location";
import {OfferingFormGroup} from "../types";
import {ServiceGenInfoFormFields} from "../../services/gen-info";
import {ServicePricingFormFields} from "../../services/pricing";
import {ServiceSettingsFormFields} from "../../services/settings";
import {ServiceDeliveryTimeframeFormFields} from "../../services/delivery-timeframe";
import {EditStoreServiceCoverImagesUpload} from "../../../../service-feature/useCases/edit-service/cover-images";
import {EditStoreServicePortfolioImagesUpload} from "../../../../service-feature/useCases/edit-service/portfolio-images";

export const CreateSessionOfferingFormGroups: OfferingFormGroup = [
  {
    offering: "session",
    children: <SessionGenInfoFormFields />,
    title: "General information",
  },
  {
    offering: "session",
    children: <></>,
    title: "Pricing",
  },
  {
    offering: "session",
    children: <SessionAvailabilityFormFields />,
    title: "Availability",
  },
  {
    offering: "session",
    children: <SessionLocationFormFields />,
    title: "Location",
  },
  {
    offering: "session",
    children: <></>,
    title: "Redirect after purchase",
  },
  {
    offering: "session",
    children: <></>,
    title: "Settings",
  },
];

export const EditSessionOfferingFormGroups: OfferingFormGroup = [
  {
    offering: "session",
    children: <SessionGenInfoFormFields />,
    title: "General information",
  },
  {
    offering: "session",
    children: <EditSessionCoverImagesUpload />,
    title: "Cover image",
  },
  {
    offering: "session",
    children: <></>,
    title: "Pricing",
  },
  {
    offering: "session",
    children: <SessionAvailabilityFormFields />,
    title: "Availability",
  },
  {
    offering: "session",
    children: <SessionLocationFormFields />,
    title: "Location",
  },
  {
    offering: "session",
    children: <></>,
    title: "Redirect after purchase",
  },
  {
    offering: "session",
    children: <></>,
    title: "Settings",
  },
];

export const CreateBundleOfferingFormGroups: OfferingFormGroup = [
  {
    offering: "bundle",
    children: <BundleSessionGenInfoFormFields />,
    title: "General information",
  },
  {
    offering: "bundle",
    children: <BundleSessionSessionPeriodFormFields />,
    title: "Session period",
  },
  {
    offering: "bundle",
    children: <></>,
    title: "Pricing",
  },
  {
    offering: "bundle",
    children: <BundleSessionAvailabilityFormFields />,
    title: "Availability",
  },
  {
    offering: "bundle",
    children: <BundleSessionLocationFormFields />,
    title: "Location",
  },
  {
    offering: "bundle",
    children: <></>,
    title: "Redirect after purchase",
  },
  {
    offering: "bundle",
    children: <></>,
    title: "Settings",
  },
];

export const EditBundleOfferingFormGroups: OfferingFormGroup = [
  {
    offering: "bundle",
    children: <BundleSessionGenInfoFormFields />,
    title: "General information",
  },
  {
    offering: "bundle",
    children: <BundleSessionSessionPeriodFormFields />,
    title: "Session period",
  },
  {
    offering: "bundle",
    children: <EditBundleCoverImagesUpload />,
    title: "Cover image",
  },
  {
    offering: "bundle",
    children: <></>,
    title: "Pricing",
  },
  {
    offering: "bundle",
    children: <BundleSessionAvailabilityFormFields />,
    title: "Availability",
  },
  {
    offering: "bundle",
    children: <BundleSessionLocationFormFields />,
    title: "Location",
  },
  {
    offering: "bundle",
    children: <></>,
    title: "Redirect after purchase",
  },
  {
    offering: "bundle",
    children: <></>,
    title: "Settings",
  },
];

export const SessionCheckoutFormGroups: OfferingFormGroup = [
  {
    offering: "session",
    children: <OfferingFormCheckoutFormWrapper />,
    title: "Checkout form",
  },
];

export const BaseProductOfferingFormGroups: OfferingFormGroup = [
  {
    offering: "product",
    children: (
      <ProductGenInfoFormFields
        coverImageFieldId="productCoverImage"
        coverImageFieldLabel="Cover Image"
        coverImageFieldPlaceholder=""
        descriptionFieldId="productDescription"
        descriptionFieldLabel="Product description"
        descriptionFieldPlaceholder="What is your product about"
        nameFieldId="productName"
        nameFieldLabel="Product name"
        nameFieldPlaceholder="e.g Marketing 101"
      />
    ),
    title: "General information",
  },
  {
    offering: "product",
    children: <ProductPricingFormFields />,
    title: "Pricing",
  },
  {
    offering: "product",
    children: <></>,
    title: "Redirect after purchase",
  },
  {
    offering: "product",
    children: <ProductSettingsFormFields />,
    title: "Settings",
  },
];
export const CreateProductOfferingFormGroups: OfferingFormGroup =
  BaseProductOfferingFormGroups;

export const EditProductOfferingFormGroups: OfferingFormGroup = [
  {
    offering: "product",
    children: (
      <ProductGenInfoFormFields
        coverImageFieldId="productCoverImage"
        coverImageFieldLabel="Cover Image"
        coverImageFieldPlaceholder=""
        descriptionFieldId="productDescription"
        descriptionFieldLabel="Product description"
        descriptionFieldPlaceholder="What is your product about"
        nameFieldId="productName"
        nameFieldLabel="Product name"
        nameFieldPlaceholder="e.g Marketing 101"
      />
    ),
    title: "General information",
  },
  {
    offering: "product",
    children: <EditProductCoverImagesUpload />,
    title: "Cover image",
  },
  {
    offering: "product",
    children: <ProductPricingFormFields />,
    title: "Pricing",
  },
  {
    offering: "product",
    children: <></>,
    title: "Redirect after purchase",
  },
  {
    offering: "product",
    children: <ProductSettingsFormFields />,
    title: "Settings",
  },
];

export const ProductCheckoutFormGroups: OfferingFormGroup = [
  {
    offering: "product",
    children: <OfferingFormCheckoutFormWrapper />,
    title: "Checkout form",
  },
];
export const ProductVariantsFormGroups: OfferingFormGroup = [
  {
    offering: "product",
    children: <></>,
    title: "Add-ons",
  },
];

export const BaseServiceOfferingFormGroups: OfferingFormGroup = [
  {
    offering: "service",
    children: (
      <ServiceGenInfoFormFields
        nameFieldId="serviceName"
        nameFieldLabel="Service name"
        nameFieldPlaceholder="e.g Logo design"
        descriptionFieldId="serviceDescription"
        descriptionFieldLabel="Service description"
        descriptionFieldPlaceholder="What is your service about?"
      />
    ),
    title: "General information",
  },
  {
    offering: "service",
    children: <ServicePricingFormFields />,
    title: "Pricing",
  },

  {
    offering: "service",
    children: (
      <ServiceDeliveryTimeframeFormFields
        deliveryTimeFrameUnitFormFieldId="service-delivery-time-frame-unit-form-id"
        deliveryTimeFrameUnitFormFieldLabel=""
        deliveryTimeFrameUnitFormFieldPlaceholder=""
        deliveryTimeFrameValueFormFieldId="service-delivery-time-frame-value-form-id"
        deliveryTimeFrameValueFormFieldLabel=""
        deliveryTimeFrameValueFormFieldPlaceholder=""
      />
    ),
    title: "Delivery Time frame",
  },
  {
    offering: "service",
    children: <></>,
    title: "Redirect after purchase",
  },
  {
    offering: "service",
    children: <ServiceSettingsFormFields />,
    title: "Settings",
  },
];

export const CreateServiceOfferingFormGroups: OfferingFormGroup =
  BaseServiceOfferingFormGroups;

export const EditServiceOfferingFormGroups: OfferingFormGroup = [
  {
    offering: "service",
    children: (
      <ServiceGenInfoFormFields
        nameFieldId="serviceName"
        nameFieldLabel="Service name"
        nameFieldPlaceholder="e.g Logo design"
        descriptionFieldId="serviceDescription"
        descriptionFieldLabel="Service description"
        descriptionFieldPlaceholder="What is your service about?"
      />
    ),
    title: "General information",
  },
  {
    children: <EditStoreServiceCoverImagesUpload />,
    offering: "service",
    title: "Cover images",
  },
  {
    children: <EditStoreServicePortfolioImagesUpload />,
    offering: "service",
    title: "Portfolio images",
  },
  {
    offering: "service",
    children: <ServicePricingFormFields />,
    title: "Pricing",
  },

  {
    offering: "service",
    children: (
      <ServiceDeliveryTimeframeFormFields
        deliveryTimeFrameUnitFormFieldId="service-delivery-time-frame-unit-form-id"
        deliveryTimeFrameUnitFormFieldLabel=""
        deliveryTimeFrameUnitFormFieldPlaceholder=""
        deliveryTimeFrameValueFormFieldId="service-delivery-time-frame-value-form-id"
        deliveryTimeFrameValueFormFieldLabel=""
        deliveryTimeFrameValueFormFieldPlaceholder=""
      />
    ),
    title: "Delivery Time frame",
  },
  {
    offering: "service",
    children: <></>,
    title: "Redirect after purchase",
  },
  {
    offering: "service",
    children: <ServiceSettingsFormFields />,
    title: "Settings",
  },
];

export const ServiceCheckoutFormGroups: OfferingFormGroup = [
  {
    offering: "service",
    children: <OfferingFormCheckoutFormWrapper />,
    title: "Checkout form",
  },
];

export const SubscriptionCheckoutFormGroups: OfferingFormGroup = [
  {
    offering: "product-subscription",
    children: <OfferingFormCheckoutFormWrapper />,
    title: "Checkout form",
  },
];

export const LiveEventOfferingFormGroups: OfferingFormGroup = [
  {
    offering: "event",
    children: <LiveEventGenInfoFormFields />,
    title: "General information",
  },
  {
    offering: "event",
    children: <EditLiveEventCoverImagesUpload />,
    title: "Cover image",
  },
  {
    offering: "event",
    children: <></>,
    title: "Event type",
  },
  {
    offering: "event",
    children: <></>,
    title: "Pricing",
  },
  {
    offering: "event",
    children: <LiveEventAttendeesFormFields />,
    title: "Attendees",
  },
  {
    offering: "event",
    children: <LiveEventLocationFormFields />,
    title: "Location",
  },
  {
    offering: "event",
    children: <></>,
    title: "Redirect after purchase",
  },
  {
    offering: "event",
    children: <></>,
    title: "Settings",
  },
];
export const LiveEventCheckoutFormGroups: OfferingFormGroup = [
  {
    offering: "event",
    children: <OfferingFormCheckoutFormWrapper />,
    title: "Checkout form",
  },
];
